/* eslint-disable radix */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/state-in-constructor */
import { createContext, Component } from '@wordpress/element';
import data from '../data/data.json';

const UserContext = createContext();

class UserProvider extends Component {
    state = {
        data: [],
        country: 'Bangladeshi',
        groupData: {
            group: 'Bangladeshi',
            population: 188000,
            order: 12,
            'Foreign born': 74,
            'U.S. citizen†': 57,
            'Living in the U.S. more than 10 years†': 51,
            'High school or less': 35,
            'Bachelor"s degree or more': 48,
            'Speak English proficiently': 55,
            'Median age (in years)': 31,
            'Married (among adults)': 73,
            'Women ages 15 to 44 who gave birth in past 12 months': 5,
            'Living in multigenerational household': 32,
            'Median household income': 49800,
            'Homeownership rate': 40,
            'Living in poverty': 24.2,
            'Unemployment rate': 7.2,
            note: '',
        },
        activeTab: 'Population Totals',
        note: '',
    };

    componentDidMount() {
        this.orderData();
    }

    orderData = () => {
        const orderedData = data.sort((a, b) =>
            parseInt(a.population) < parseInt(b.population) ? 1 : -1,
        );

        this.setState({ data: orderedData });
    };

    updateGroupData = group => {
        this.state.data.map(groupData => {
            if (groupData.group === group) {
                this.setState({ groupData, country: groupData.group });
            }
        });
    };

    setNote = note => this.setState({ note });

    render() {
        const { children } = this.props;
        const { updateGroupData, setNote } = this;

        return (
            <UserContext.Provider
                value={{
                    ...this.state,
                    updateGroupData,
                    setNote,
                }}
            >
                {children}
            </UserContext.Provider>
        );
    }
}

export default UserContext;

export { UserProvider };
